import React from 'react';

import Div from '../../../div';

export default ({ openIces, openPlayers }) =>
    <Div setup='r start center' wRel='100' css='ViewHeader'>
        <Div class='padLeft'>Nasledujúce ľady</Div>
    </Div>
